import axios from 'axios';
import { getApiBaseUrl } from '../config';

// Get token from localStorage
const getAuthHeader = () => {
    const token = localStorage.getItem('parentToken');
    return token ? { Authorization: `Bearer ${token}` } : {};
};

export const schoolService = {
    // Get school registration details
    getSchoolDetails: async () => {
        const response = await axios.get(`${getApiBaseUrl()}/school-registrations`, {
            headers: getAuthHeader()
        });
        return response.data;
    }
};
